import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTableColumn } from '../../../../shared/ui/data-table/data-table.component';
import { Errors, FileService, LocalService, SellerService, formatDate } from '../../../../core';
import { sellerApi } from '../../../../config';

@Component({
  selector: 'app-reward-tickets-tab',
  templateUrl: './reward-tickets-tab.component.html',
  styleUrls: ['./reward-tickets-tab.component.scss'],
})
export class RewardTicketsTabComponent implements OnInit {
  private userProfile: any;
  errors: Errors = { errors: {} };

  tktDateForm: FormGroup = null as any;

  pageNo = 0;
  size = 5;
  sortBy: any;
  startDate2: any;
  endDate2: any;
  minDate2: any;
  maxDate2: any;

  isLoading: boolean = false;
  ticketTransactionHistory: any;
  ticketsPage: number = 1;

  ticketsTableColumns: DataTableColumn[] = [
    { field: 'date', header: 'Date', align: 'center' },
    { field: 'creditsEarned', header: 'Tickets Earned', align: 'center', highlight: 'green' },
    { field: 'creditsRedeemed', header: 'Tickets Redeemed', align: 'center', highlight: 'orange' },
    { field: 'currentBalance', header: 'Current Balance', align: 'center', isBold: true },
  ];

  get ticketsRows() {
    const content = this.ticketTransactionHistory && this.ticketTransactionHistory.content
      ? this.ticketTransactionHistory.content : [];
    return content.map((item: any) => ({
      ...item,
      date: item.date ? new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '-',
      creditsEarned: item.creditsEarned != null ? item.creditsEarned.toLocaleString('en-US') : '-',
      creditsRedeemed: item.creditsRedeemed != null ? item.creditsRedeemed.toLocaleString('en-US') : '-',
      currentBalance: item.currentBalance != null ? item.currentBalance.toLocaleString('en-US') : '-',
    }));
  }

  constructor(
    private sellerService: SellerService,
    private formBuilder: FormBuilder,
    private fileService: FileService,
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.generateFormTickets();
    this.getticketTransactionHistory({ pageSize: this.size, pageIndex: this.pageNo });
  }

  generateFormTickets() {
    this.tktDateForm = <FormGroup>this.formBuilder.group(
      {
        startDate2: ['', [Validators.required]],
        completeBy2: ['', [Validators.required]],
      },
      this.checkTicketDates.bind(this)
    );
  }

  checkTicketDates(group: FormGroup): { notValid: boolean } | null {
    if (
      group.controls.startDate2.value &&
      group.controls.completeBy2.value &&
      group.controls.completeBy2.value < group.controls.startDate2.value
    ) {
      return { notValid: true };
    }
    return null;
  }

  searchByNameTickets() {
    Object.keys(this.tktDateForm.controls).forEach((key: string) => {
      const control = this.tktDateForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
    if (this.tktDateForm.valid) {
      this.startDate2 = formatDate(this.tktDateForm.controls.startDate2.value, 'YYYY-MM-DD HH:mm:ss');
      this.endDate2 = formatDate(this.tktDateForm.controls.completeBy2.value, 'YYYY-MM-DD HH:mm:ss');
      this.getticketTransactionHistoryBySearch(this.startDate2, this.endDate2);
    }
  }

  getticketTransactionHistoryBySearch(startDate2?: any, endDate2?: any) {
    this.pageNo = 0;
    const params: any = {
      page: this.pageNo,
      size: this.size,
      userId: this.userProfile.id,
    };
    if (startDate2 && endDate2) {
      params.startDate = startDate2;
      params.endDate = endDate2;
    }
    if (this.sortBy) {
      params.sortBy = this.sortBy.active;
      params.sortDir = this.sortBy.direction;
    }
    this.isLoading = true;
    this.sellerService.getTicketTransaction(params).subscribe(
      (data: any) => { this.isLoading = false; this.ticketTransactionHistory = data; },
      (err: any) => { this.isLoading = false; this.ticketTransactionHistory = ''; this.errors = err; }
    );
  }

  getticketTransactionHistory(pageNo: any) {
    this.size = pageNo.pageSize;
    this.pageNo = pageNo.pageIndex;
    const params: any = {
      userId: this.userProfile.id,
      size: this.size,
      page: this.pageNo,
    };
    if (this.startDate2 && this.endDate2) {
      params.startDate = this.startDate2;
      params.endDate = this.endDate2;
    }
    this.isLoading = true;
    this.sellerService.getTicketTransaction(params).subscribe(
      (data: any) => { this.isLoading = false; this.ticketTransactionHistory = data; },
      (err: any) => { this.isLoading = false; this.errors = err; }
    );
  }

  clearSearchTickets() {
    this.startDate2 = '';
    this.endDate2 = '';
    this.tktDateForm.reset();
    this.pageNo = 0;
    this.sortBy = null;
    this.getticketTransactionHistory({ pageSize: this.size, pageIndex: this.pageNo });
  }

  onTicketsPageChange(page: number) {
    this.ticketsPage = page;
    this.getticketTransactionHistory({ pageIndex: page - 1, pageSize: this.size });
  }

  downloadExcel() {
    const fileName = 'Tickets_Transaction_History_' + this.userProfile.company.id + '.xlsx';
    const url = sellerApi.ticketTransactionHistory + '?userId=' + this.userProfile.id + '&size=100000&excel=true';
    this.fileService.excelDownloadFile(url, fileName);
  }
}
